import { render, staticRenderFns } from "./AnnouncementClose.html?vue&type=template&id=f238f858&scoped=true&external"
import script from "./AnnouncementClose.vue?vue&type=script&lang=js"
export * from "./AnnouncementClose.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementClose.scss?vue&type=style&index=0&id=f238f858&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f238f858",
  null
  
)

export default component.exports